/**
 * Lo que la pantalla sabe de un texto de SMS antes de guardarlo. Es una ayuda:
 * quien manda es el servidor, que lo vuelve a medir con el nombre de la empresa
 * (`problemaDelTexto` en modules/ar-arranque). Ver docs/ar-sms-plan.md.
 */

// Valores largos de ejemplo: lo que ocupa el SMS con un nombre y un importe largos.
const EJEMPLO = { nombre: 'Maximiliano', importe: '99.999,99 €' };

/** Lo que ocupa un texto de SMS con las variables rellenas de ejemplo. `{acreedor}` cuenta como está escrito. */
export function longitudSms(texto) {
  return String(texto || '').replace(/\{\s*(nombre|importe)\s*\}/g, (_, v) => EJEMPLO[v]).length;
}

/** Textos de partida: se ofrecen para copiar, no se guardan solos. */
export const SMS_DE_PARTIDA = {
  first: 'Hola {nombre}, le escribe {acreedor}: tiene pendiente una factura de {importe}. Puede responder a este SMS.',
  second: 'Hola {nombre}, {acreedor} le recuerda la factura pendiente de {importe}. Puede responder a este SMS.',
};

export const VARIABLES_SMS = [
  { name: 'nombre', label: 'Nombre de pila del deudor' },
  { name: 'importe', label: 'Lo que debe, con céntimos' },
  { name: 'acreedor', label: 'El nombre de tu empresa (obligatorio)' },
];
